import type { ChannelUnsubscribe } from 'shared/channels';
import { serveAnalyticsRequests } from './analyticsServer';
import { serveChartFiltersRequests } from './chartFiltersServer';
import { serveChecklistAnswerRequests } from './checklistAnswerServer';
import { serveChecklistSectionRequests } from './checklistSectionServer';
import { serveCompanyRequests } from './companyServer';
import { serveContractRequests } from './contractServer';
import { serveCurrentUserRequests } from './currentUserServer';
import { serveDbChangesRequests } from './dbChangesServer';
import { serveDirectoryRequests } from './directoryServer';
import { serveDocumentationRequests } from './documentationServer';
import { serveDocumentRequests } from './documentServer';
import { serveFieldValueRequests } from './fieldValueServer';
import { serveHttpQueueRequests } from './httpQueueServer';
import { serveIssueFormRequests } from './issueFormServer';
import { serveInspectionRequests } from './inspectionServer';
import { serveInspectionTemplateRequests } from './inspectionTemplateServer';
import { serveIssueRequests } from './issueServer';
import { serveLevelRequests } from './levelServer';
import { serveLogoutRequests } from './logoutServer';
import { serveOrganizationRequests } from './organizationServer';
import { serveProcessRequests } from './processServer';
import { serveProjectDataRequests } from './projectDataServer';
import { serveProjectRequests } from './projectServer';
import { serveReportRequests } from './reportServer';
import { serveSelectedProjectRequests } from './selectedProjectServer';
import { serveServiceWorkerConfigRequests } from './serviceWorkerConfigServer';
import { serveSiteRequests } from './siteServer';
import { serveUserRequests } from './userServer';
import { serveVisibleFieldRequests } from './visibleFieldServer';
import { serveWorkflowRequests } from './workflowServer';

let stopServing: ChannelUnsubscribe | null = null;

/**
 * Request handling of every contract migrated to the channel server. Idempotent:
 * a second call keeps the running servers instead of registering duplicate
 * handlers. Returns the unsubscribe of all servers.
 */
export function serveChannelRequests(): ChannelUnsubscribe {
  if (!stopServing) {
    const unsubscribes = [
      serveDocumentationRequests(),
      serveDirectoryRequests(),
      serveFieldValueRequests(),
      serveSiteRequests(),
      serveLevelRequests(),
      serveCompanyRequests(),
      serveContractRequests(),
      serveUserRequests(),
      serveCurrentUserRequests(),
      serveOrganizationRequests(),
      serveProjectRequests(),
      serveProjectDataRequests(),
      serveSelectedProjectRequests(),
      serveProcessRequests(),
      serveWorkflowRequests(),
      serveIssueFormRequests(),
      serveVisibleFieldRequests(),
      serveIssueRequests(),
      serveInspectionTemplateRequests(),
      serveInspectionRequests(),
      serveChecklistSectionRequests(),
      serveChecklistAnswerRequests(),
      serveDocumentRequests(),
      serveReportRequests(),
      serveHttpQueueRequests(),
      serveAnalyticsRequests(),
      serveChartFiltersRequests(),
      serveServiceWorkerConfigRequests(),
      serveLogoutRequests(),
      serveDbChangesRequests(),
    ];
    stopServing = (): void => {
      unsubscribes.forEach((unsubscribe) => unsubscribe());
      stopServing = null;
    };
  }
  return stopServing;
}
